module.exports = __webpack_public_path__ + "static/media/RQ4.ef8eaa4b.pdf";